/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
  INIT_TODO: 'todos/INIT_TODO',
  ADD_TODO: 'todos/ADD_TODO',
  TOGGLE_TODO: 'todos/TOGGLE_TODO',
  DELETE_TODO: 'todos/DELETE_TODO',
  UPDATE_TODO: 'todos/UPDATE_TODO',
};

// count state 必須是 Object
const state = {
  list: [],
  todos: [],
};

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
  getDone: s => (s.todos.filter(items => items.done)),
  getTodo: s => (s.todos.filter(items => !items.done)),
};

// actions 也是以 Object 形式建構。
const actions = {
  initTodo({ commit }) {

    setTimeout(() => {
      const ajaxResultTodos = [
        {
          key: 0, 
          content: 'Vuejs 2.0',
          done: true,
        },
        {
          key: 1, 
          content: 'Vuex 2.0',
          done: false,
        },
        {
          key: 2, 
          content: 'Vue-route 2.0',
          done: false,
        },
        {
          key: 3, 
          content: 'Vue-resource 2.0',
          done: true,
        },
        {
          key: 4, 
          content: 'webpack',
          done: false,
        },
      ];
    
      commit(types.INIT_TODO, ajaxResultTodos);
    }, 5000);

  },
  
  addTodo({ commit }, newTodo) {
    commit(types.ADD_TODO, newTodo);
  },

  toggleTodo({ commit }, key) {
    commit(types.TOGGLE_TODO, key);
  },

  deleteTodo({ commit }, key) {
    commit(types.DELETE_TODO, key);
  },

  updateTodo({ commit }, obj) {
    commit(types.UPDATE_TODO, obj);
  },
};

// mutations
const mutations = {
  [types.INIT_TODO](s, t) {
    s.todos = t;
  },
  [types.ADD_TODO](s, newTodo) {
    let todoKey = s.todos.length;

    s.todos.push({
      key: todoKey,
      content: newTodo,
      done: false,
    });

    todoKey += 1;
  },
  [types.TOGGLE_TODO](s, key) {
    s.todos.forEach((t) => {
      if (t.key === key) {
        t.done = !t.done;
        console.log('TOGGLE_TODO: ', t.content, 'done?', t.done);
      }
    });
  },
  [types.DELETE_TODO](s, key) {
    s.todos = s.todos.filter(t => (t.key !== key));
  },
  [types.UPDATE_TODO](s, obj) {
    console.log('obj', obj);
    s.todos.forEach((t) => {
      if (t.key === obj.key) {
        console.log('UPDATE_TODO:', t.content, ' to →', obj.change);
        t.content = obj.change;
      }
    });
  },
};

/*
  因為我們把 vuex 所有職權都寫在同一隻檔案，
  所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/todos.js